module.exports = __webpack_public_path__ + "static/media/compatibility-grey.99d43a59.svg";